@if (content().headline; as headline) {
  <section class="page-section page-section-x-padded">
    <h1>{{ headline }}</h1>
  </section>
}

@if (content().heroImage; as heroImg) {
  <section class="hero-image-section">
    <p-image imageClass="hero-img" [src]="heroImg.url" [alt]="heroImg.description" [loading]="imageLoading.LAZY" />
  </section>
}

@if (content().heroBanner; as HeroBannerContent) {
  <section class="hero-banner-section w-full max-w-full overflow-hidden">
    <ppg-hero-banner [content]="HeroBannerContent.content" />
  </section>
}

@if (featuredAreaSection(); as featuredAreaContent) {
  <section class="section-items-container w-full">
    @for (featureCard of featuredAreaContent; track $index) {
      <ppg-shared-component-renderer [component]="featureCard" [isRoot]="true" />
    }
  </section>
}

@if (mainSection(); as mainSectionContent) {
  <section
    class="main-area"
    [class]="mainSectionContent.haveSidebar ? 'page-section page-section-x-padded with-sidebar flex' : 'w-full'">
    @if (mainSectionContent.mainContentArea; as mainContent) {
      <section
        class="section-items-container"
        [class.main-content-area-limited]="mainSectionContent.haveSidebar"
        [class.main-content-area-full]="!mainSectionContent.haveSidebar">
        @for (contentItem of mainContent; track $index) {
          <ppg-shared-component-renderer
            [component]="contentItem"
            [isRoot]="true"
            [fullWidth]="mainSectionContent.haveSidebar" />
        }
      </section>
    }

    @if (mainSectionContent.sidebarArea; as sidebar) {
      <aside class="sidebar-area section-items-container sidebar-{{ content().sidebarPosition }}">
        @for (sidebarItem of sidebar; track $index) {
          <ppg-shared-component-renderer [component]="sidebarItem" [fullWidth]="true" [isRoot]="true" />
        }
      </aside>
    }
  </section>
}

@if (postContentAreaSection(); as postContent) {
  <section class="section-items-container w-full">
    @for (postContentItem of postContent; track $index) {
      <ppg-shared-component-renderer [component]="postContentItem" [isRoot]="true" />
    }
  </section>
}
